module.exports = __webpack_public_path__ + "img/priority-pass.bf10c08a.jpg";